<!-- 表二列表 -->

<template>
  <div class="ListCage ssTab4">
    <div class="tabTtl">
      <span>人员基本信息</span>
      <div class="tabBtns">
        <el-button @click="goBack" size="mini">返回</el-button>
      </div>
    </div>
    <!-- <div class="percentTab" v-if="role == 'show'">
      <table>
        <tr>
          <td colspan="2">人数统计</td>
          <td colspan="2">岗位培训合格证书持有统计</td>
          <td colspan="2">出版专业职业资格证书持有情况统计</td>
        </tr>
        <tr>
          <td>岗位类别</td>
          <td>人员数（人）</td>

          <td>持证人数</td>
          <td>占比</td>

          <td>中级以上</td>
          <td>占比</td>
        </tr>

        <tr v-for="(term,inx) in percentArr">
          <template v-if="inx < 2">
            <td>{{ term.workerType | transStr('type') }}</td>
            <td>{{ term.thisWorker }}</td>

            <td>{{ term.certificateWorker }}</td>
            <td rowspan="2" v-if="inx == 0">
              {{munCount[0].certificateWorkerProportion}}
            </td>

            <td>{{ term.zjCertificate }}</td>
            <td rowspan="2" v-if="inx == 0">{{ term | pecCount(percentArr,2) }}</td>
          </template>
          <template v-else>
            <td>{{ term.workerType | transStr('type') }}</td>
            <td>{{ term.thisWorker }}</td>
            <td> ———— </td>
            <td> ———— </td>
            <td>{{ term.zjCertificate }}</td>
            <td>{{ term | pecCount(percentArr,3) }}</td>
          </template>

        </tr>

      </table>
    </div> -->
    <div class="ctrlsLine">
      <el-radio-group v-model="seekPms.type" @change="tabSeek">
        <el-radio :label="0">全部</el-radio>
        <el-radio :label="1">主要负责人</el-radio>
        <el-radio :label="2">其他负责人</el-radio>
        <el-radio :label="3">编辑人员</el-radio>
      </el-radio-group>
      <el-input v-model="seekPms.keyword" size="small" 
        placeholder="通过姓名，身份证号（军官证号），手机号查询"></el-input>
      <!-- <el-button class="seekBtn" @click="tabSeek('init')" size="small">查询</el-button> -->
    </div>

    <div class="tabForms">
      <el-table :data="tabDat" border style="width: 100%" 
        @selection-change="selectionChange" 
        v-loading="loading">
        <el-table-column type="selection" width="45"></el-table-column>
        <el-table-column label="序号" width="60" align="center" type="index">
        </el-table-column>
        <el-table-column prop="fullName" label="姓名" width="120" align="center">
        </el-table-column>
        <el-table-column label="性别" width="60" align="center">
          <template slot-scope="scope">
            {{ scope.row.gender|translate('C017',dicMap) }}
          </template>
        </el-table-column>
        <el-table-column prop="idNumber" label="身份证号（军官证号）" width="270" align="center">
        </el-table-column>
        <el-table-column label="职务" width="90" align="center">
          <template slot-scope="scope">
            {{ scope.row.job|translate('C022',dicMap) }}
          </template>
        </el-table-column>
        <el-table-column label="政治面貌" width="90" align="center">
          <template slot-scope="scope">
            {{ scope.row.politicalStatus|translate('C006',dicMap) }}
          </template>
        </el-table-column>
        <el-table-column label="文化程度" width="90" align="center">
          <template slot-scope="scope">
            {{ scope.row.culture|translate('C005',dicMap) }}
          </template>
        </el-table-column>
        <el-table-column prop="major" label="专业" width="90" align="center">
        </el-table-column>
        <el-table-column label="职称系列" width="90" align="center">
          <template slot-scope="scope">
            {{ scope.row.professionalTitleSeries|translate('C007',dicMap) }}
          </template>
        </el-table-column>
        <el-table-column label="职称级别" width="90" align="center">
          <template slot-scope="scope">
            {{ scope.row.titleLevel|translate('C008',dicMap) }}
          </template>
        </el-table-column>
        <el-table-column label="是否持有岗位培训资格证书" align="center">
          <template slot-scope="scope">
            {{ scope.row.isTrainCertificate|translate('C018',dicMap) }}
          </template>
        </el-table-column>
        <el-table-column prop="cellphone" label="手机号" align="center">
        </el-table-column>
        <el-table-column label="操作" width="150" align="center">
          <template slot-scope="scope">
            <el-button type="primary" @click="memberEdit(2,scope.row)" size="mini">查看</el-button>

          </template>
        </el-table-column>
      </el-table>

      <div class="headBar">
        <span>申报人信息</span>
      </div>
      <div class="editArea">
        <table>
          <tr>
            <td class="edName">申报人：</td>
            <td class="edInp">
              <el-input disabled v-model="declare.personnel" size="small" placeholder="请输入申报人"></el-input>
            </td>
          </tr>
          <tr>
            <td class="edName">联系方式：</td>
            <td class="edInp">
              <el-input disabled v-model="declare.contact" size="small" placeholder="请输入申报人联系方式"></el-input>
            </td>
          </tr>
          <tr>
            <td class="edName">申报时间：</td>
            <td class="edInp">
              <el-input v-model="updatedAt" size="small" :disabled="true"></el-input>
            </td>
          </tr>
        </table>
      </div>
    </div>

  </div>
</template>

<script>
  import {
    ssList4,
    ssRemove4,
    ssClean4
  } from '@/api/pressRole/pressSuccessive';
  import {
    percentCountLxdz // zym.连续型电子出版物提交之后，进入人员列表页面，调用了这个统计的方法
  } from '@/api/pressRole/pressRole';
  export default {
    data() {
      return {

        querys: {
          pressId: '',
          mtId: '',
          pgress: '',
          listId: '',
          bookName: ''
        },
        loading: false,
        tabDatAll: [], // zym.所有的数据
        tabDat: [], // zym.列表上的数据
        detArrs: [],
        dicMap: {},
        seekPms: {
          type: 0,
          keyword: '',
          no: 1,
          size: 15
        },

        percentArr: [],
        munCount: {},
        role: '',
        
        declare: {
          personnel: "",
          contact: ""
        },
        updatedAt:'',
      }
    },
    filters: {
      translate: function (dat, code, transMap) {
        return transMap[code][dat];
      },
      transStr: function (dat, code) {
        if (code == 'type') {
          let map = {
            1: "主要负责人",
            2: "其他负责人",
            3: "编辑人员"
          }

          return map[dat];
        }
      },
      pecCount: function (dat, arrDat, type) {
        if (type == 1) {
          if (arrDat[0].thisWorker + arrDat[1].thisWorker == 0) {
            return '0%';
          } else {
            var pct = (arrDat[0].certificateWorker + arrDat[1].certificateWorker) / (arrDat[0].thisWorker + arrDat[1]
              .thisWorker);
            pct = (pct * 100 + '').substr(0, 5) + '%';
            return pct;
          }
        } else if (type == 2) {
          if (arrDat[0].thisWorker + arrDat[1].thisWorker == 0) {
            return '0%';
          } else {
            var pct = (arrDat[0].zjCertificate + arrDat[1].zjCertificate) / (arrDat[0].thisWorker + arrDat[1]
              .thisWorker);
            pct = (pct * 100 + '').substr(0, 5) + '%';
            return pct;
          }
        } else if (type == 3) {
          if (arrDat[2].thisWorker == 0) {
            return '0%';
          } else {
            var pct = arrDat[2].zjCertificate / arrDat[2].thisWorker;
            pct = (pct * 100 + '').substr(0, 5) + '%';
            return pct;
          }

        }

      },
    },
    
    watch: {
      seekPms: {
        deep: true, //实现深度监听
        handler(v) {
          this.filterTableData()
        }
      }
    },
    methods: {
      tabSeek: function (type) {
        this.loading = true;
        if (type == 'init') {
          this.seekPms.no = 1;
        }

        // ssList4(this.seekPms).then(response => {
        ssList4({
          publishMaterialId: this.$route.query.mtId,
        }).then(response => {
          let vm = this;
          setTimeout(function () {
            vm.loading = false;
            // console.log('response=',JSON.stringify(response))
            // vm.tabDat = response.plxdzWorkerList;
            vm.tabDatAll = response.plxdzWorkerList;
            vm.modifyFlag = response.modifyFlag;
            console.log('modifyFlag=', vm.modifyFlag)

            vm.filterTableData();
          }, 300)
          this.declare.contact = response.pOrganizationPersonnel.contact;
          this.declare.personnel = response.pOrganizationPersonnel.personnel;
          this.updatedAt = response.pOrganizationPersonnel.updatedAt;
        })
      },
      
      // zym.过滤列表数据
      filterTableData: function () {
        let tabDat = this.tabDatAll;
        let qType = this.seekPms.type;
        let qKeyword = this.seekPms.keyword;
        // !人员类型
        if (qType) {
          tabDat = tabDat.filter(function (item) {
            if ((item.type || '') == qType) {
              return true;
            }
            return false;
          });
        }
        // !关键字查询
        if (qKeyword) {
          tabDat = tabDat.filter(function (item) {

            if ((item.fullName || '').indexOf(qKeyword) > -1 ||
              (item.idNumber || '').indexOf(qKeyword) > -1 ||
              (item.cellphone || '').indexOf(qKeyword) > -1) {
              return true;
            }
            return false;
          });
        }

        this.tabDat = tabDat;
      },
      memberDet: function (type, dat) {

        let detSure = false;
        let vm = this;

        if (type == 1) {
          if (this.detArrs.length > 0) {
            detSure = true;
          } else {
            this.$message.error('请勾选人员！');
          }
        } else if (type == 2) {
          detSure = true;
        }

        if (detSure) {
          this.$confirm('确定删除吗？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            let params = {};
            if (type == 1) {
              params.ids = vm.detArrs;
            } else if (type == 2) {
              params.ids = [dat.id];
            }

            params.publishMaterialId = this.$route.query.mtId;
            ssRemove4(params).then(response => {
              this.tabSeek();
            }).catch(error => {});
          }).catch(() => {});
        }

      },
      memberClean: function () {
        this.$confirm('此操作会删除所有已录入数据库的人员信息，确定全部清除吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          ssClean4({
            type: this.$route.query.pressType
          }).then(response => {
            this.seekPms.type = 0;
            this.keyword = '';
            this.no = 1;
            this.tabSeek();
          })
        }).catch(() => {});
      },
      selectionChange: function (selection) {
        let newArr = [];
        for (let i = 0; i < selection.length; i++) {
          newArr.push(selection[i].id);
        }
        this.detArrs = newArr;
      },
      dictInit: function () {
        let nameArr = ['C022', 'C017', 'C018', 'C006', 'C005', 'C007', 'C008', 'C009'];
        let newPromise = this.$store.dispatch('dictUpdate', {
          codeArr: nameArr,
          type: 'map'
        });
        newPromise.then(result => {
          this.dicMap = result;
          this.tabSeek();
        })

        // zym.连续型电子出版物提交之后，进入人员列表页面，调用了这个统计的方法
        percentCountLxdz({
          materialId: this.$route.query.mtId
        }).then(response => {
          // console.log('response=',JSON.stringify(response));
          // let unFormate = response.workerproportion;
          this.percentArr = response.pWorkerSum;
          console.log('this.percentArr=',JSON.stringify(this.percentArr));
          // this.munCount = response.pWorkerProportion;
        })

      },
      // zym.人员信息查看
      memberEdit: function (type, dat) {
        let pathParams = {
          pressId: this.$route.query.pressId,
          mtId: this.$route.query.mtId,
          pgress: 2,

          listId: this.$route.query.listId,
          bookName: this.$route.query.bookName,
        }

        if (dat) {
          pathParams.id = dat.id;
        }

        this.$router.push({
          path: 'ss_skimtab4',
          query: pathParams
        })
      },

      goBack: function () {
        this.$router.go(-1);
      }
    },
    created: function () {

      this.querys.pressId = this.$route.query.pressId;
      this.querys.mtId = this.$route.query.mtId;
      this.querys.pgress = this.$route.query.pgress;
      this.querys.listId = this.$route.query.listId;
      this.querys.bookName = this.$route.query.bookName;

      this.seekPms.publishMaterialId = this.$route.query.mtId;
      this.role = this.$route.query.role;
      this.dictInit();
    }
  }
</script>

<style lang="scss">
@import "src/styles/pressRoleL";

.ssTab4 {
  
    .percentTab table {
        width: 100%;
        border-collapse: collapse;
        margin-top: 30px;
        td {
            text-align: center;
            border: 1px solid #ebeef5;
            padding: 12px;
        }
    }
  .saveBtn {
    margin: 50px 400px;

    .el-button {
      width: 150px;
      margin-right: 10px;
    }
  }

  .headBar {
    padding: 0px 24px;
    height: 45px;
    line-height: 45px;
    background: #F8F8F8;
    color: #666666;
    margin-top: 20px;
  }

  .editArea {
    table {
      width: 80%;
      margin: 30px auto;

      tr {
        display: block;
        margin-top: 20px;
      }

      .edName {
        width: 300px !important;
        text-align: right;
      }

      .edInp {
        padding-left: 15px;

        .el-input {
          width: 300px;
        }
      }
    }

  }

  .editArea table .edName {
    width: 210px;
  }

  .el-button+.el-button {
    margin-left: 0px;
  }

  .ctrlsLine {
    padding: 12px;

    .tips {
      font-size: 12px;
      margin-top: 12px;
      color: salmon;
    }

    .el-radio__label {
      margin-left: -5px;
    }

    .el-input {
      display: inline-block;
      width: 360px;
      margin-left: 20px;

      input {
        border-radius: 0;
      }
    }

    .el-button+.el-button {
      margin-left: 0;
    }

    .el-radio+.el-radio {
      margin-left: 20px;
    }

    .seekBtn {
      margin-right: 20px;
    }

    .excelRead {
      float: right;
    }
  }

  .tabForms {
    .el-button+.el-button {
      margin-left: 0;
    }
  }
}
</style>


// WEBPACK FOOTER //
// ssTab4.vue?33f9027a